<template>
  <b-row class="responsavel-row">
    <b-col>
      <cabecalho-repeticao
        :show-icon="true"
        :mostrar-adicionar="mostrarAdicionar"
        titulo="Controle de vencimento"
        @remove="removerItem"
        @apply="adicionarItem"
      />
      <b-row style="margin-top: 1.3rem;">

        <b-col
          cols="2"
          class="pr-0 pl-50"
        >
          <validation-provider
            #default="{ errors }"
            name="Validacao tipo"
          >
            <b-form-group
              :label="'Tipo'"
            >
              <b-form-select
                v-model="valueInner.tipo"
                :options="tipoCertificado"
                :style="valueInner.erro && !valueInner.tipo ? 'border-color: #ea5455' : ''"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>

        <b-col
          cols="2"
          class="pr-0 pl-50"
        >
          <b-form-group
            :label="'Dias antes ao vencimento'"
          >
            <validation-provider
              #default="{ errors }"
              name="Validacao Vencimento"
              :rules="!valueInner.tipo || valueInner.tipo === 'None' ? '' : 'required'"
            >
              <b-select
                v-model="valueInner.diasAntesVencimento"
                :disabled="!valueInner.tipo || valueInner.tipo === 'None'"
              >
                <option
                  :value="null"
                />
                <option
                  v-for="$index in 365"
                  :key="$index"
                  :value="$index"
                >{{ $index == 1 ? $index + ' dia' : $index + ' dias' }}</option>
              </b-select>
              <small class="text-danger">{{ errors[0] || (valueInner.tipo && !valueInner.diasAntesVencimento) ? 'O campo Dias antes ao vencimento é obrigatório' : "" }}</small>
            </validation-provider></b-form-group>
        </b-col>
        <b-col
          cols="1"
          class="pr-0 pl-50"
        >
          <b-form-group
            :label="'Intervalo'"
          >
            <b-select
              v-model="valueInner.intervaloCobranca"
              :disabled="!valueInner.tipo || valueInner.tipo === 'None'"
            >
              <option :value="null" />
              <option
                v-for="$index in 31"
                :key="$index"
                :value="$index"
              >{{ $index }}</option>
            </b-select>
          </b-form-group>
        </b-col>

        <b-col
          cols="7"
        >
          <email-input
            :value="valueInner.emailCC"
            :require="false"
            :disabled="!valueInner.tipo || valueInner.tipo === 'None'"
            :label="'E-mail certificadora (CC)'"
            @input="adicionarEmail($event)"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

  <style lang="scss">
  .usuarios-responsaveis {
      th {
          padding-left: 1%;
          display: none;
        }
    }

    .usuarios-responsaveis tbody tr td:first-child{
        padding-left: 1%;
        width: 49.8%;
    }

  .titulo-Cadastro {
    padding-top: .6rem;
    border-bottom: 1px solid #0000006e;
    background-color: #ede6b1;
  }

  .responsavel-row {
    &:hover {
      background-color: rgba(24, 28, 33, 0.03);
      border-radius: 1px;
    }
  }

  .check-remetente {
    margin-top: 3.5%;
  }

  .usuario-ativo-badge {
    height: 1.2rem;
    font-size: 10px;
    font-weight: 600;
    border-radius: 2px;
    margin-left: 0.5rem;
  }
  </style>

<script>

import {
} from '@fortawesome/free-solid-svg-icons'
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'

export default {
  name: 'ControleVencimento',
  components: {
    ValidationProvider,
    CabecalhoRepeticao: () => import('@/shared/components/cabecalho-repeticao/CabecalhoRepeticao.vue'),
    EmailInput: () => import('@/@pilar/components/email-input/EmailInput.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => { },
    },
    mostrarAdicionar: {
      type: Boolean,
      default: true,
    },
    tipoCertificado: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      required,
      tirarValidacao: false,
      mostrarNull: true,
      valueInner: {
        emailCC: [],
        tipo: null,
        diasAntesVencimento: null,
        intervaloCobranca: null,
      },
    }
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
        if (this.valueInner.tipo !== 'None') {
          this.mostrarNull = false
        }
      }
    },
    tipoCertificado(value, oldValue) {
      if (value !== oldValue) {
        this.tipoCertificado = value
      }
    },
  },
  created() {
    this.valueInner = this.value
    if (this.valueInner.tipo !== 'None') {
      this.mostrarNull = false
    }
  },
  methods: {
    adicionarEmail(value) {
      this.valueInner.emailCC = value
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    removerItem() {
      this.$emit('remove', this.valueInner)
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    adicionarItem() {
      this.$emit('add-item')
    },
  },
}
</script>
